module.exports = __webpack_public_path__ + "static/Core-2f8f45b3e295382ebd797f03c3332c6a.png";